<template>
  <div class="terms">
    <Header />

    <v-content>
      <v-container>
        <v-card flat class="pb-12">
          <h2 class="mb-2 text-center">利用規約</h2>
          <p>この規約は、ユーザーが、本サービス制作者が提供する「競技かるた配置めも」をご利用頂く際の取扱いにつき定めるものです。本規約に同意した上で本サービスをご利用ください。</p>

          <h3 class="mb-2">第1条（本規約への同意）</h3>
          <ol class="mb-4">
            <li>ユーザーは、本利用規約に同意頂いた上で、本サービスを利用できるものとします。</li>
            <li>ユーザーが、本規約への同意手続を行った時点で、ユーザーと本サービス制作者との間で、本規約の諸規定に従った利用契約が成立するものとします。</li>
            <li>ユーザーが未成年者である場合には、親権者その他の法定代理人の同意を得たうえで、本サービスをご利用ください。</li>
            <li>未成年者のユーザーが、法定代理人の同意がないにもかかわらず同意があると偽りまたは年齢について成年と偽って本サービスを利用した場合、その他行為能力者であることを信じさせるために詐術を用いた場合、本サービスに関する一切の法律行為を取り消すことは出来ません。</li>
            <li>本規約の同意時に未成年であったユーザーが成年に達した後に本サービスを利用した場合、当該ユーザーは本サービスに関する一切の法律行為を追認したものとみなされます。</li>
          </ol>

          <h3 class="mb-2">第2条（規約の変更）</h3>
          <ol class="mb-4">
            <li>本サービス制作者は、ユーザーの承諾を得ることなく、いつでも、本規約の内容を改定することができるものとし、ユーザーはこれを異議なく承諾するものとします。</li>
            <li>本サービス制作者は、本規約を改定するときは、その内容について本サービス制作者所定の方法によりユーザーに通知します。</li>
            <li>前本規約の改定の効力は、本サービス制作者が前項により通知を行った時点から生じるものとします。</li>
            <li>ユーザーは、本規約変更後、本サービスを利用した時点で、変更後の本利用規約に異議なく同意したものとみなされます。</li>
          </ol>

          <h3 class="mb-2">第3条（アカウントの管理）</h3>
          <ol class="mb-4">
            <li>ユーザーは、利用に際して登録した情報（以下、「登録情報」といいます。メールアドレスやパスワード等を含みます）について、自己の責任の下、任意に登録、管理するものとします。ユーザーは、これを第三者に利用させ、または貸与、譲渡、名義変更、売買などをしてはならないものとします。</li>
            <li>本サービス制作者は、登録情報によって本サービスの利用があった場合、利用登録をおこなった本人が利用したものと扱うことができ、当該利用によって生じた結果ならびにそれに伴う一切の責任については、利用登録を行った本人に帰属するものとします。</li>
          </ol>

          <h3 class="mb-2">第4条（個人情報等の取り扱い）</h3>
          <p>個人情報及びユーザー情報については、本サービス制作者が別途定める「競技かるた配置めもプライバシーポリシー」に則り、適正に取り扱うこととします。</p>

          <h3 class="mb-2">第5条（コンテンツの取り扱い）</h3>
          <ol class="mb-4">
            <li>ユーザーが、本サービス上に登録したデータ（文字情報その他一切の情報）に関する著作権（著作権法第21条ないし同第28条に規定する権利を含む全ての著作権を含む。）についてはユーザーに帰属するものとします。ただし、ユーザーは、コンテンツの送信時に、本サービス制作者に対し、日本国内外において、当該コンテンツを無償かつ非独占的に使用することを許諾します。</li>
            <li>ユーザーは本サービス内では、著作者人格権を行使しなものとします。</li>
          </ol>

          <h3 class="mb-2">第6条（サービスの終了）</h3>
          <ol class="mb-4">
            <li>本サービス制作者は、ユーザーへの適宜の方法で通知することにより、本サービスを終了することができるものとします。</li>
            <li>本サービス制作者は、本サービスが原因を問わず終了した場合、これに起因して生じたユーザーまたは第三者が被った損害について、一切責任を負わないものとします。</li>
          </ol>

          <h3 class="mb-2">第7条（禁止行為）</h3>
          <p>本サービスの利用に際し、本サービス制作者は、ユーザーに対し、次に掲げる行為を禁止します。本サービス制作者において、ユーザーが禁止事項に違反したと認めた場合、利用の一時停止、退会処分その他本サービス制作者が必要と判断した措置を取ることができます。</p>
          <ol class="mb-4">
            <li>本サービス制作者または第三者の知的財産権を侵害する行為</li>
            <li>本サービス制作者または第三者の名誉・信用を毀損または不当に差別もしくは誹謗中傷する行為</li>
            <li>コンピューターウィルス、有害なプログラムを仕様またはそれを誘発する行為</li>
            <li>本サービス用インフラ設備に対して過度な負担となるストレスをかける行為</li>
            <li>当サイトのサーバーやシステム、セキュリティへの攻撃</li>
            <li>上記の他、本サービス制作者が不適切と判断する行為</li>
          </ol>

          <h3 class="mb-2">第8条（免責）</h3>
          <ol class="mb-4">
            <li>本サービス制作者は、本サービスの内容変更、中断、終了によって生じたいかなる損害についても、一切責任を負いません。</li>
            <li>本サービス制作者は、ユーザーの本サービスの利用環境について一切関与せず、また一切の責任を負いません。</li>
            <li>本サービス制作者は、本サービスがユーザーの特定の目的に適合すること、期待する機能・商品的価値・正確性・有用性を有すること、ユーザーによる本サービスの利用がユーザーに適用のある法令または業界団体の内部規則等に適合すること、および不具合が生じないことについて、何ら保証するものではありません。</li>
            <li>本サービス制作者は、本サービスが全ての情報端末に対応していることを保証するものではなく、本サービスの利用に供する情報端末のＯＳのバージョンアップ等に伴い、本サービスの動作に不具合が生じる可能性があることにつき、ユーザーはあらかじめ了承するものとします。本サービス制作者は、かかる不具合が生じた場合に本サービス制作者が行うプログラムの修正等により、当該不具合が解消されることを保証するものではありません。</li>
            <li>本サービス制作者は、本サービスを利用したことにより直接的または間接的にユーザーに発生した損害について、一切賠償責任を負いません。</li>
            <li>本サービス制作者は、ユーザーその他の第三者に発生した機会逸失、業務の中断その他いかなる損害（間接損害や逸失利益を含みます）に対して、本サービス制作者が係る損害の可能性を事前に通知されていたとしても、一切の責任を負いません。</li>
            <li>ユーザーと他のユーザーとの間の紛争及びトラブルについて、本サービス制作者は一切責任を負わないものとします。ユーザーと他のユーザーでトラブルになった場合でも、両者同士の責任で解決するものとし、本サービス制作者には一切の請求をしないものとします。</li>
          </ol>

          <h3 class="mb-2">第9条（本サービス制作者への連絡方法）</h3>
          <p>本サービスの利用規約に関する質問やお問い合わせは、メール（karuta.develop.miya@gmail.com）にご連絡ください。</p>

          <h3 class="mb-2">第10条（準拠法、管轄裁判所）</h3>
          <ol class="mb-4">
            <li>本規約の有効性，解釈及び履行については，日本法に準拠し，日本法に従って解釈されるものとします。</li>
            <li>本サービス制作者とユーザー等との間での論議・訴訟その他一切の紛争については、訴額に応じて、東京簡易裁判所又は東京地方裁判所を専属的合意管轄裁判所とします。</li>
          </ol>

          <p>2020年6月1日施行</p>

          <BtnWindowClose />
        </v-card>
      </v-container>
    </v-content>

    <Footer />
  </div>
</template>

<script>
import Header from "./../components/Header";
import Footer from "./../components/Footer";
import BtnWindowClose from "./../components/BtnWindowClose";

export default {
  name: "Terms",
  components: {
    Header,
    Footer,
    BtnWindowClose
  }
};
</script>